'use client';

import { UAEntityTypes } from '@unifyapps/defs/types/entities';
import type { InterfaceEntity } from '@unifyapps/defs/types/interface';
import { useFindDeployedEntityById } from '@unifyapps/network/generated/entity-rest-api/entity-rest-api';
import { InterfaceClient } from '../../../../../../stores/InterfaceStore';
import type { UseFetchInterfaceAppResourcesHookType } from '../../../../types';
import { useGetAuthDeployedInterface } from '../../useAuthDeployedInterface';
import { useAuthAppResourcesFromRecord } from './useAuthAppResourcesFromRecord';

// Authorization strategy (governance app resources): resolves the record by domain/host, falling
// back to the authenticated entity-by-id route. Platform auth pages use the PlatformAuthorization
// strategy hook instead of branching here on a flag.
const useFetchAuthDeployedInterfaceAppResources: UseFetchInterfaceAppResourcesHookType = ({
  interfaceId,
  client,
  mode,
}) => {
  const authEntityInterface = useGetAuthDeployedInterface<InterfaceEntity>({
    query: {
      enabled: client === InterfaceClient.UA_MATRIX,
      staleTime: Infinity,
    },
  });

  const {
    data,
    isLoading,
    error: findEntityError,
  } = useFindDeployedEntityById<InterfaceEntity>(UAEntityTypes.Interface, interfaceId, {
    query: {
      enabled: Boolean(interfaceId) && client === InterfaceClient.UA_PLATFORM,
    },
  });

  // TODO: not fetching app level page data and data sources here yet as we do not support app level stuff in governance pages yet
  // to do that we need to whitelist the app page slug of that e_component here

  return useAuthAppResourcesFromRecord({
    interfaceId,
    client,
    mode,
    interfaceRecord: authEntityInterface.data || data,
    isLoadingInterfaceRecord: authEntityInterface.isLoading || isLoading,
    errorInterfaceRecord: authEntityInterface.error || findEntityError,
    overrideSource: client === InterfaceClient.UA_MATRIX ? 'auth-domain' : 'search',
  });
};

export default useFetchAuthDeployedInterfaceAppResources;
